import { styled, Stack, StackProps, Typography } from '@mui/material';
import { Button, ButtonProps } from '@braskai/ui-kit';

export const Title = styled(Typography)({
  textAlign: 'left',
});

type ContentProps = {
  isDisabled: boolean;
} & StackProps;

export const Content = styled(Stack, { shouldForwardProp: (prop) => prop !== 'isDisabled' })<ContentProps>(
  ({ isDisabled }) => ({
    padding: '0 24px',
    gap: 16,

    ...(isDisabled && {
      opacity: 0.5,
      pointerEvents: 'none',
    }),
  }),
);

export const Actions = styled(Stack)({
  flexDirection: 'row',
  padding: '20px 24px 24px',
  gap: 12,
});

export const SubmitButton = styled((props: ButtonProps) => <Button size="lg" fullWidth {...props} />)('');

export const CancelButton = styled((props: ButtonProps) => (
  <Button size="lg" variant="outlined" fullWidth {...props} />
))('');
